import styled from "@emotion/styled";
import { Button } from "@mui/material";

const CustomButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  padding: "6px 12px",
  border: "1px solid",
  lineHeight: 1.5,
  backgroundColor: "#ffffff", // Set your desired background color
  borderColor: "#0063cc", // Set your desired border color
  fontFamily: [
    "Rubik",
    "-apple-system",
    "BlinkMacSystemFont",
    "Segoe UI",
    "Roboto",
    "Helvetica Neue",
    "Arial",
    "sans-serif",
    "Apple Color Emoji",
    "Segoe UI Emoji",
    "Segoe UI Symbol",
  ].join(","),
  "&:hover": {
    boxShadow: "none",
    borderColor: "#94bbe9", // Set your desired hover border color
    backgroundColor: "rgb(63,94,251)",
    background:
      "linear-gradient(190deg, rgba(63,94,251,1) 0%, rgba(252,70,188,1) 100%)",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#0062cc", // Set your desired active background color
    borderColor: "#005cbf", // Set your desired active border color
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem rgba(0, 123, 255, .5)",
  },
});

export default CustomButton;
